import { ForumMessage } from '../models/comments'
import { UserHelper } from '../Techedge-digitalportal-shared'

export const getChildBorderConfig = (childIds, nodeIds) => {
    return {
        hasChildBorderTop: childIds?.length > 0 && nodeIds.length === 1,
        hasChildBorderBottom: nodeIds.length === 2,
        hasChildBorderBottomSecond:
            childIds?.length > 0 && nodeIds.length === 2,
        hasThirdChildBorderBottom: nodeIds.length === 3,
    }
}

export const getMessageListFromApi = (
    messages,
    userId: string,
    parentNodeIds?: string[]
): ForumMessage[] => {
    return messages.map((m) => {
        if (!!m.id) {
            m.uploadList = []
            // delete m.showLoadMore
            delete m.isLoadMoreLoading
            delete m.isLoadReaction
            delete m.isLoadEditSave
            return {
                ...m,
                ...getChildBorderConfig(m.replyList, m.nodeIds),
            }
        }

        return {
            id: m._id,
            userName: m.creator.firstname,
            userLastname: m.creator.lastname,
            avatarImage: m.creator.attachment?.url,
            comment: m.text,
            parentCommentId: m.reference.parentId,
            reactions: m.reactions.map((r) => r.reaction),
            userReaction: m.reactions.find(
                (r) => r.userInfo.userId === UserHelper._shared().user().user_id
            )?.reaction,
            // nickname: m.creator.userId,
            nickname: `${m.creator.firstname || ''} ${
                m.creator.lastname || ''
            }`,
            alias: m.creator.nickname,
            messageTime: m.creationDate,
            attachmentList: m.attachments,
            replyList: m.replyList || [],
            nodeIds: m.nodeIds || [...(parentNodeIds || []), m._id],
            isRead: m.isRead,
            isGif: m.isGif,
            enableDropdown: m.creator.userId === userId,
            disableReply:
                m.nodeIds?.length > 2 ||
                [...(parentNodeIds || []), m._id].length > 2,
            showLoadMore: m.reference.childIds?.length > 0,
            ...getChildBorderConfig(
                m.replyList,
                m.nodeIds || [...(parentNodeIds || []), m._id]
            ),
        }
    })
}
